const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'accidents';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'accidents',
  DETAIL_ACCIDENT: ':id',
  EDIT_ACCIDENT: 'edit/:id',
  EDIT: 'edit',
  CARS: 'cars',
  SHIPS: 'ships',
  DETAIL_ACCIDENT_TRANSPORT: 'transport/:id',
  DETAIL_ACCIDENT_TRANSPORT_LINK: 'transport',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Siniestros',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-car',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CARS),
        title: 'Automóviles',
        activated: true,
      },
      {
        icon: 'pi pi-truck',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.SHIPS),
        title: 'Transporte',
        activated: false,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DETAIL_ACCIDENT),
    title: 'Detalle del siniestro',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CARS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.EDIT_ACCIDENT),
    title: 'Editar siniestro',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CARS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.DETAIL_ACCIDENT_TRANSPORT
    ),
    title: 'Detalle del siniestro',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.SHIPS),
  },
];

export const DATA_TABS = {
  DATA_ACCIDENT: 'datosSiniestro',
  DATA_POLICY: 'datosPoliza',
  DATA_CLAIM: 'datosAccidente',
  DATA_IMAGES: 'imagenesAdjuntas',
  DATA_CLAIMANTS: 'reclamantes',
};

export const TAB_ACTION = {
  EDIT: 'edit',
  VIEW: 'view',
};

export const ESTADO_SINIESTRO = {
  PROCESANDO: 'Procesando',
  INGRESADO_SAP: 'Ingresado SAP',
  ARCHIVADO: 'Archivado',
  FALLIDO: 'Fallido',
  PROCESADO: 'Procesado',
};

// Motivos de fallo del siniestro (campo motivoFallo) que habilitan la
// edición de Matrícula y Número de chasis para reprocesar la denuncia
export const MOTIVO_FALLO_SINIESTRO = {
  VEHICULO_NO_ENCONTRADO: 'VehiculoNoEncontrado',
  INCONSISTENCIA_FECHAS: 'InconsistenciaFechas',
};

export const TIPO_DOCUMENTO = ['CI', 'RUT'];

export const DEPARTAMENTO = [
  'Montevideo',
  'Artigas',
  'Canelones',
  'CerroLargo',
  'Colonia',
  'Durazno',
  'Flores',
  'Florida',
  'Lavalleja',
  'Maldonado',
  'Paysandu',
  'RioNegro',
  'Rivera',
  'Rocha',
  'Salto',
  'SanJose',
  'Soriano',
  'Tacuarembo',
  'TreintayTres',
  'Extranjero',
];

export const CATEGORIA_LICENCIA = ['Categoría A', 'Categoría B'];

export const TIPO_PATENTE = ['Patente A', 'Patente B'];

export const DATA_CLAIMANTS_TABS = {
  PERSONA: 'persona',
  VEHICULO: 'vehiculo',
  COSA: 'cosa',
  ANIMAL: 'animal',
};

export const TIPO_RECLAMO = {
  PERSONA: 1,
  VEHICULO: 2,
  COSA: 3,
  ANIMAL: 4,
};

export const RESPONSABILIDAD_ASEGURADO = {
  CULPABLE: '1',
  RESPONSABILIDAD_COMPARTIDA: '3',
  INOCENTE: '4',
};

export const ESTADO_IMAGEN_SINIESTRO = {
  PROCESANDO: 'Procesando',
  INGRESADO_SAP: 'Ingresado Sap',
  ARCHIVADO: 'Archivado',
  FALLIDO: 'Fallido',
};

export const ESTADO_RECLAMANTES_SAP = {
  PROCESANDO: 'Procesando',
  INGRESADO_SAP: 'Ingresado Sap',
  EN_ESPERA: 'En Espera',
  FALLIDO: 'Fallido',
};

export const ESTADO_RECLAMANTES = {
  OK: 0,
  FALLIDO: 1,
  EN_ESPERA: 2,
};

export const AUTO_ACCIDENT_STATUS = {
  PROCESADO: 'Procesado',
  FALLIDO: 'Fallido',
  ENVIADO: 'Enviado',
};

export const AUTO_ACCIDENT_CLAIMANT = {
  ESPERA: 'En espera',
  FALLIDO: 'Fallido',
  INGRESADO: 'Ingresado',
  SIN_INGRESAR: 'Sin ingresar',
};

export const AUTO_ACCIDENT_STATUS_ORIGIN = {
  PROCESADO: 'Procesando',
  FALLIDO: 'Fallido',
  ENVIADO: 'Ingresado SAP',
};

export enum StatusClasses {
  PROCESADO = 'green',
  FALLIDO = 'red',
  ENVIADO = 'lightblue',
}

// Estados de la columna "Adjuntos SAP" (EstadoDeAdjuntos) — semántica propia, distinta de
// AUTO_ACCIDENT_STATUS/StatusClasses (EstadoDeProceso): acá "Enviado" es el estado de éxito.
export const AUTO_ACCIDENT_ATTACHMENTS_STATUS = {
  ENVIADO: 'Enviado',
  PROCESANDO: 'Procesando',
  FALLIDO: 'Fallido',
};

export enum AttachmentsStatusClasses {
  ENVIADO = 'green',
  PROCESANDO = 'lightblue',
  FALLIDO = 'red',
}

export const AUT_ACCIDENT_ATTACHMENTS_TYPE_OPTIONS = [
  { name: AUTO_ACCIDENT_ATTACHMENTS_STATUS.ENVIADO, value: AUTO_ACCIDENT_ATTACHMENTS_STATUS.ENVIADO },
  { name: AUTO_ACCIDENT_ATTACHMENTS_STATUS.PROCESANDO, value: AUTO_ACCIDENT_ATTACHMENTS_STATUS.PROCESANDO },
  { name: AUTO_ACCIDENT_ATTACHMENTS_STATUS.FALLIDO, value: AUTO_ACCIDENT_ATTACHMENTS_STATUS.FALLIDO },
];

export enum ClaimantClasses {
  ESPERA = 'yellow',
  FALLIDO = 'red',
  INGRESADO = 'green',
  SIN_INGRESAR = 'grey',
}

export const AUT_ACCIDENT_TYPE_OPTIONS = [
  {
    name: AUTO_ACCIDENT_STATUS.PROCESADO,
    value: AUTO_ACCIDENT_STATUS.PROCESADO,
  },
  {
    name: AUTO_ACCIDENT_STATUS.FALLIDO,
    value: AUTO_ACCIDENT_STATUS.FALLIDO,
  },
  {
    name: AUTO_ACCIDENT_STATUS.ENVIADO,
    value: AUTO_ACCIDENT_STATUS.ENVIADO,
  },
];

export const AUT_ACCIDENT_CLAIMANT_TYPE_OPTIONS = [
  {
    name: AUTO_ACCIDENT_CLAIMANT.ESPERA,
    value: AUTO_ACCIDENT_CLAIMANT.ESPERA,
  },
  {
    name: AUTO_ACCIDENT_CLAIMANT.FALLIDO,
    value: AUTO_ACCIDENT_CLAIMANT.FALLIDO,
  },
  {
    name: AUTO_ACCIDENT_CLAIMANT.INGRESADO,
    value: AUTO_ACCIDENT_CLAIMANT.INGRESADO,
  },
  {
    name: AUTO_ACCIDENT_CLAIMANT.SIN_INGRESAR,
    value: AUTO_ACCIDENT_CLAIMANT.SIN_INGRESAR,
  },
];

export const ORIGEN_SINIESTRO = {
  AUXICAR: { codigo: 1, valor: 'Auxicar' },
  HEYNOW: { codigo: 2, valor: 'HeyNow' },
};

export const FILE_TYPE = {
  IMAGEN: 'image/',
  IMAGEN_OLD: 'img',
  PDF: 'application/',
  AUDIO: 'audio/',
};
